import PlainDatePicker, { PlainDatePickerProps } from './plain-date-picker'
import { PlainDatePickerDouble, PlainDatePickerDoubleProps } from './plain-date-picker-double'


export default PlainDatePicker

export { PlainDatePickerDouble }

export type { PlainDatePickerProps, PlainDatePickerDoubleProps }
